import type { BetterstartIntegrationDefinition } from '@integration-engine/types.js'

export const vercelBlobIntegration: BetterstartIntegrationDefinition = {
  id: 'vercel-blob',
  title: 'Vercel Blob',
  description: 'Remote media storage on Vercel Blob',
  kind: 'storage',
  version: '1.0.0',
  dependencies: [],
  conflicts: [],
  files: [
    {
      outputPath: 'lib/actions/vercel-blob/provider.ts',
      templatePath: 'actions/vercel-blob.ts'
    }
  ],
  packageDependencies: ['@vercel/blob'],
  devDependencies: [],
  capabilities: {
    storageProvider: {
      provider: 'vercel-blob',
      importPath: '@admin/actions/vercel-blob/provider',
      exportName: 'vercelBlobStorageProvider'
    }
  },
  envSections: [
    {
      // BLOB_READ_WRITE_TOKEN is deliberately unprefixed: it is the name the
      // @vercel/blob SDK reads by default and the one Vercel injects into
      // deployments when a Blob store is connected to the project.
      header: 'Storage (Vercel Blob)',
      vars: [{ key: 'BLOB_READ_WRITE_TOKEN', value: '' }]
    }
  ],
  configure: 'vercel-blob'
}
